export default __webpack_public_path__ + "static/SR USA - Halal - Certificate-8e26b5314bb8349e9e22360f439af6b4.pdf";